module.exports = __webpack_public_path__ + "static/img/团队成员-郭迪伟.2cda7ce1.jpg";